// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__1MyKy","paymentContainer":"PaymentPage_paymentContainer__3fGnu"};